import { withInstall } from '@bigin/utils'
import Lottie from './src/lottie.vue'

export const BLottie = withInstall(Lottie)

export default BLottie

export * from './src/lottie'
